import * as React from 'react';
import { translate } from 'components/translate-hoc';
import { ConfigContext } from 'modules/context';

// types
import { IItemSelectionPageProps } from './item-selection-page.types';
import { IAgeRatings } from '@sitegen/common/constants/age-ratings';

// components
import Button from 'components/button';
import { Icon, ICON_NAME } from 'components/icon';
import AgeRatings from 'modules/age-ratings';
import PlatformBanner from 'modules/platform-banner';

// utils
import AnalyticsService from 'modules/analytics-provider/analytics-provider.service';
import { onImageError } from '../success/success.utils';

// constants
import { ITEMS_SELECTION_FLOW_STEP, TEXT_KEYS } from './item-selection-page.constants';
import { CATEGORY } from 'modules/analytics-provider/analytics-provider.constants';

import './item-selection-page.styles.less';

class ItemSelectionPage extends React.PureComponent<IItemSelectionPageProps> {
    public componentDidMount() {
        AnalyticsService.sendFlowEvent({
            ...ITEMS_SELECTION_FLOW_STEP,
            category: CATEGORY.DISPLAY,
            action: ITEMS_SELECTION_FLOW_STEP.flowStep
        });
    }

    private goToItemsDisplayPage = (): void => {
        AnalyticsService.sendFlowEvent({
            ...ITEMS_SELECTION_FLOW_STEP,
            category: CATEGORY.INTERACTION,
            action: 'back to selection'
        });
        this.props.goToItemsDisplayPage();
    };

    private submitGameItem = (): void => {
        const { contentGameItem: { packId } } = this.props;
        AnalyticsService.sendFlowEvent({
            ...ITEMS_SELECTION_FLOW_STEP,
            category: CATEGORY.INTERACTION,
            action: `item selected: ${packId}`
        });
        this.props.submitGameItem();
    };

    public render(): JSX.Element {
        const {
            contentGameItem: {
                imageSrc = '',
                packId,
                ratings = {},
            },
            platformList,
            dangerouslyTranslateWithHTML: translateKey,
            originalTranslateKey
        } = this.props;
        const { getModeClass, config: { shouldInheritStyles } } = this.context;
        return (
            <div className={getModeClass('sitegen-redeem-item-selection-page')}>
                <div className={getModeClass('sitegen-redeem-item-selection-page__content')}>
                    <div
                        className={getModeClass('sitegen-redeem-item-selection-page__back-title')}
                        onClick={this.goToItemsDisplayPage}>
                        <Icon name={ICON_NAME.ANGLE_LEFT}/>
                        {translateKey(TEXT_KEYS.REDEEM_ITEM_BACK_SELECTION)}
                    </div>
                    <div className={getModeClass('sitegen-redeem-item-selection-page__item-block')}>
                        <div className={getModeClass('sitegen-redeem-item-selection-page__item-block__image-block')}>
                            <img
                                onError={onImageError}
                                src={imageSrc as string}
                                alt=""
                            />
                        </div>
                        <div className={getModeClass('sitegen-redeem-item-selection-page__item-block__info-block')}>
                            <div className={getModeClass('sitegen-redeem-item-selection-page__item-block__info-block__name')}>
                                {originalTranslateKey([`${TEXT_KEYS.REDEEM_SUCCESS_GIFT_DESCRIPTION}__${packId}`, ''])}
                            </div>
                            <div className={getModeClass('sitegen-redeem-item-selection-page__item-block__info-block__description')}>
                                {translateKey([`${TEXT_KEYS.REDEEM_SUCCESS_GIFT_DETAILS}__${packId}`, ''])}
                            </div>
                            <div className={getModeClass('sitegen-redeem-item-selection-page__item-block__info-block__banners')}>
                                <AgeRatings ratings={ratings as IAgeRatings}/>
                                <PlatformBanner platformList={platformList}/>
                            </div>
                            <Button onClick={this.submitGameItem} shouldInheritStyles={shouldInheritStyles}>
                                {translateKey(TEXT_KEYS.REDEEM_ITEM_SELECT_GAME)}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ItemSelectionPage.contextType = ConfigContext;

export default translate()(ItemSelectionPage);
